// La dirección de un archivo del chat (04-11-2026). Antes estaba copiada en tres sitios (la conversación, la galería y
// el visor); ahora todo sale de aquí. Mismo servidor que el resto del panel (getActiveBaseUrl), la sesión va en la cookie.
import { getActiveBaseUrl } from '../../../stores/servers.store';

const base = (agentId: string, id: string) => `${getActiveBaseUrl()}/api/agents/${encodeURIComponent(agentId)}/attachments/${encodeURIComponent(id)}`;

/** Los bytes tal cual (imagen, PDF, texto). */
export const urlArchivo = (agentId: string, id: string): string => `${base(agentId, id)}/raw`;

/** La portada de un PDF: su página 1 en WebP, dibujada y guardada por el servidor (backend/src/attachments/portadas.ts). */
export const urlPortada = (agentId: string, id: string): string => `${base(agentId, id)}/portada`;

/** Las imágenes de un informe llegan como «adjunto:<id>» (backend/src/oficina/informe.ts); otra ruta no se puede enseñar. */
export function imagenDeInforme(agentId: string, src: string): string | null {
  const m = /^adjunto:([\w-]+)$/.exec(src);
  return m ? urlArchivo(agentId, m[1]!) : null;
}
